import type {LazyMasonryGridProps} from '@Components/lazy-masonry-grid/lazy-masonry-grid';

export interface TextToImageGridProps extends Partial<LazyMasonryGridProps> {
  isLoading?: boolean;
  errorState: TextToImageGridErrorState;
  onRetry?(): void;
  infographicClasses?: string;
  infographicTextClasses?: string;
  gridClasses?: string;
  isHidden?: boolean;
  gridId: string;
}

export enum TextToImageGridErrorState {
  NONE,
  GENERIC,
  FLAGGED,
  UNSUPPORTED_LANUAGE,
}
